module.exports = __webpack_public_path__ + "static/media/18ECA51.8784ed2a.jpg";